<template>
  <b-table :items="airports" :fields="fields">
    <template #name="{ item }">
      <router-link :to="{ name: 'airports.edit', params: { id: item.id } }">
        {{ item.name }}
      </router-link>
    </template>
    <template #is_main="{ item }">
      <i v-if="item.is_main" class="icon-checkmark text-success" />
      <span v-else>&nbsp;</span>
    </template>
    <template #actions="{ item }">
      <b-button variant="danger" size="sm" @click="deleteAction(item)">
        <i class="icon-trash" /> {{ $t('general.delete') }}
      </b-button>
    </template>
  </b-table>
</template>

<script>
export default {
  props: {
    airports: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      fields: [
        {
          key: 'id',
          label: this.$t('general.id'),
        },
        {
          key: 'name',
          label: this.$t('general.name'),
          sortable: true,
        },
        {
          key: 'is_main',
          label: this.$t('general.main'),
          sortable: true,
        },
        {
          key: 'direction',
          label: this.$t('general.direction'),
          sortable: true,
          sortByFormatted: true,
          formatter: value => {
            return this.$t('general.' + value)
          },
        },
        {
          key: 'actions',
        },
      ],
    }
  },

  methods: {
    deleteAction(airport) {
      this.$emit('delete', airport)
    },
  },
}
</script>
